module.exports = "/_next/static/images/270e7b3bf3eb95c25242982bcaa9d6b0-wow@0.5x.png";